import {
  DATA_PRIVACY_PERSONALIZATION_PAYPAL,
  DATA_PRIVACY_PERSONALIZATION_PAYPAL_TOGGLE,
  DATA_PRIVACY_PERSONALIZATION_OTHER,
  DATA_PRIVACY_PERSONALIZATION_OTHER_TOGGLE,
  DATA_PRIVACY_SHOPPING,
  DATA_PRIVACY_SHOPPING_SUCCESS,
  DOWNLOAD_DATA,
  DOWNLOAD_DATA_SUCCESS,
  DATA_REQUEST,
  DATA_CORRECTION,
  DATA_DELETION,
  DATA_DELETION_SUCCESS,
  DATA_DELETION_EMAIL,
  DATA_DELETION_SURVEY,
  ZETTLE_DSR,
  ZETTLE_DSR_CASECREATION,
  ZETTLE_DSR_SUCCESS,
  ZETTLE_DSR_EMAILVERIFICATION,
  ZETTLE_EMAIL_VERIFICATIONSUCCESS,
  ZETTLE_EMAIL_VERIFICATIONEXPIRED,
  ZETTLE_EMAIL_VERIFICATIONERROR,
  ZETTLE_EMAIL_VERIFICATIONCLOSED,
  DATA_PRIVACY_CLOSEDACCOUNT,
  CLOSED_ACCOUNT_SMSSENT,
  CLOSED_ACCOUNT_LINKEXPIRED,
  CLOSED_ACCOUNT_SOMETHINGWRONG,
  DOWNLOAD_OTHERINFO,
  DOWNLOAD_OTHERINFOTT,
  DP_PROFILES_SEARCH,
  LOGGED_OUT_WELCOME,
  LOGGED_OUT_START_REQUEST_BTN,
  LOGGED_OUT_ALREADY_REQUESTED_LINK,
  LOGGED_OUT_MANAGE_YOUR_DATA,
  LOGGED_OUT_CREATE_REQUEST_BTN,
  LOGGED_OUT_CREATE_REQUEST,
  LOGGED_OUT_CONFIRM_MAIL,
  LOGGED_OUT_TRACK_REQUEST,
  LOGGED_OUT_QUICK_SECURITY,
  LOGGED_OUT_OTP_CODE,
  LOGGED_OUT_STATUS,
  LOGGED_OUT_THANKS_REQUEST,
  LOGGED_OUT_LINK_EXPIRED,
  LOGGED_OUT_EMAIL_NOT_CONFIRMED,
  LOGGED_OUT_VERIFICATION_CLOSED,
  LINKED_ACC_FOUND,
  LINKED_ACC_PAGE,
  FACESCAN_PAGE,
  FACESCAN_PAGE_MOVE_BTN,
  VENMO_PASSWORD_SENT,
  VENMO_PASSWORD_WRONG,
  VENMO_PASSWORD_EXPIRED,
} from '../constants/constants'

const DATAPRIVACY_FPTI = {
  DAR: {
    IMPRESSION: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
    },
    ACTIVITY_DOWNLOAD: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
      link: 'go_to_activity',
    },
    SELECTALL_LNK: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
      link: 'select_all',
    },
    UNSELECTALL_LNK: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
      link: 'unselect_all',
    },
    SUBMIT_BTN: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
      link: 'submit',
      field_list: '',
      file_frmt: '',
    },
    CHECKBOX: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
      link: [],
    },
    FILETYPE: {
      pgrp: DOWNLOAD_DATA,
      page: DOWNLOAD_DATA,
      link: [],
    },
    SUCCESS_IMPRESSION: {
      pgrp: DOWNLOAD_DATA_SUCCESS,
      page: DOWNLOAD_DATA_SUCCESS,
    },
    SUCCESS_DONE: {
      pgrp: DOWNLOAD_DATA_SUCCESS,
      page: DOWNLOAD_DATA_SUCCESS,
      link: 'done',
    },
    DAR_OTHER_INFO: {
      pgrp: DOWNLOAD_OTHERINFO,
      page: DOWNLOAD_OTHERINFO,
    },
    DAR_OTHER_INFO_HOVER: {
      pgrp: DOWNLOAD_OTHERINFOTT,
      page: DOWNLOAD_OTHERINFOTT,
    },
  },
  DAR_HISTORY: {
    IMPRESSION: {
      pgrp: DATA_REQUEST,
      page: DATA_REQUEST,
    },
    CREATENEW_BTN: {
      pgrp: DATA_REQUEST,
      page: DATA_REQUEST,
      link: 'create_new',
    },
    DOWNLOAD_BTN: {
      pgrp: DATA_REQUEST,
      page: DATA_REQUEST,
      link: 'download',
    },
  },
  CORRECTION: {
    IMPRESSION: {
      pgrp: DATA_CORRECTION,
      page: DATA_CORRECTION,
    },
    SETTINGS_BTN: {
      pgrp: DATA_CORRECTION,
      page: DATA_CORRECTION,
      link: 'gotosetting',
    },
    WALLET_BTN: {
      pgrp: DATA_CORRECTION,
      page: DATA_CORRECTION,
      link: 'gotowallet',
    },
    BUSINESS_INFO_BTN: {
      pgrp: DATA_CORRECTION,
      page: DATA_CORRECTION,
      link: 'gotobusiness',
    },
    ACCOUNT_INFO_BTN: {
      pgrp: DATA_CORRECTION,
      page: DATA_CORRECTION,
      link: 'gotoaccount',
    },
    MONEY_BANK_INFO_BTN: {
      pgrp: DATA_CORRECTION,
      page: DATA_CORRECTION,
      link: 'gotofinance',
    },
  },
  DELETION: {
    IMPRESSION: {
      pgrp: DATA_DELETION,
      page: DATA_DELETION,
    },
    PRIVACY_LINK: {
      pgrp: DATA_DELETION,
      page: DATA_DELETION,
      link: 'privacy_policy',
    },
    CONTACTUS_LINK: {
      pgrp: DATA_DELETION,
      page: DATA_DELETION,
      link: 'contact_us',
    },
    CONTINUE_BTN: {
      pgrp: DATA_DELETION,
      page: DATA_DELETION,
      link: 'delete_continue',
    },
    EMAIL_IMPRESSION: {
      pgrp: DATA_DELETION_EMAIL,
      page: DATA_DELETION_EMAIL,
    },
    EMAILCONTINUE_BTN: {
      pgrp: DATA_DELETION_EMAIL,
      page: DATA_DELETION_EMAIL,
      link: 'continue',
    },
    SETTINGS_LINK: {
      pgrp: DATA_DELETION_EMAIL,
      page: DATA_DELETION_EMAIL,
      link: 'go_to_settings',
    },
    FEEDBACK_IMPRESSION: {
      pgrp: DATA_DELETION_SURVEY,
      page: DATA_DELETION_SURVEY,
    },
    CHECKBOX: {
      pgrp: DATA_DELETION_SURVEY,
      page: DATA_DELETION_SURVEY,
      link: [],
    },
    SUBMIT_BTN: {
      pgrp: DATA_DELETION_SURVEY,
      page: DATA_DELETION_SURVEY,
      link: 'submit',
    },
    SUCCESS_IMPRESSION: {
      pgrp: DATA_DELETION_SUCCESS,
      page: DATA_DELETION_SUCCESS,
    },
    SUCCESS_DONE: {
      pgrp: DATA_DELETION_SUCCESS,
      page: DATA_DELETION_SUCCESS,
      link: 'done',
      comp: 'deletion_done',
    },
  },
  ZETTLE_DSR: {
    IMPRESSION: {
      pgrp: ZETTLE_DSR,
      page: ZETTLE_DSR,
    },
    GETSTARTED_BTN: {
      pgrp: ZETTLE_DSR,
      page: ZETTLE_DSR,
      link: 'get_started',
    },
    ZETTLE_EU_LINK: {
      pgrp: ZETTLE_DSR,
      page: ZETTLE_DSR,
      link: 'go_to_zettle_eu',
    },
    CASECREATION_IMPRESSION: {
      pgrp: ZETTLE_DSR_CASECREATION,
      page: ZETTLE_DSR_CASECREATION,
    },
    SUBMIT_BTN: {
      pgrp: ZETTLE_DSR_CASECREATION,
      page: ZETTLE_DSR_CASECREATION,
      link: 'submit',
    },
    PRIVACY_LINK: {
      pgrp: ZETTLE_DSR_CASECREATION,
      page: ZETTLE_DSR_CASECREATION,
      link: 'privacy_statement',
    },
    CASECREATION_SUCCESS_IMPRESSION: {
      pgrp: ZETTLE_DSR_SUCCESS,
      page: ZETTLE_DSR_SUCCESS,
    },
    CASECREATION_SUCCESS_LINKCLICK: {
      pgrp: ZETTLE_DSR_SUCCESS,
      page: ZETTLE_DSR_SUCCESS,
      link: 'request_again',
    },
    EMAILVERIFICATION_IMPRESSION: {
      pgrp: ZETTLE_DSR_EMAILVERIFICATION,
      page: ZETTLE_DSR_EMAILVERIFICATION,
    },
    EMAILVERIFICATION_SUCCESS_IMPRESSION: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONSUCCESS,
      page: ZETTLE_EMAIL_VERIFICATIONSUCCESS,
    },
    EMAILVERIFICATION_SUCCESS_LINKCLICK: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONSUCCESS,
      page: ZETTLE_EMAIL_VERIFICATIONSUCCESS,
      link: 'request_again',
    },
    EMAILVERIFICATION_EXPIRED_IMPRESSION: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONEXPIRED,
      page: ZETTLE_EMAIL_VERIFICATIONEXPIRED,
    },
    EMAILVERIFICATION_EXPIRED_LINKCLICK: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONEXPIRED,
      page: ZETTLE_EMAIL_VERIFICATIONEXPIRED,
      link: 'request_again',
    },
    EMAILVERIFICATION_ERROR_IMPRESSION: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONERROR,
      page: ZETTLE_EMAIL_VERIFICATIONERROR,
    },
    EMAILVERIFICATION_RETRY_BTN: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONERROR,
      page: ZETTLE_EMAIL_VERIFICATIONERROR,
      link: 're-try',
    },
    VERIFICATION_CLOSED_ERROR_IMPRESSION: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONCLOSED,
      page: ZETTLE_EMAIL_VERIFICATIONCLOSED,
    },
    VERIFICATION_CLOSED_NEWREQUEST_LINK: {
      pgrp: ZETTLE_EMAIL_VERIFICATIONCLOSED,
      page: ZETTLE_EMAIL_VERIFICATIONCLOSED,
      link: 'make-a-new-request',
    },
  },
  SEARCH_PRIVACY: {
    PROFILE_TOGGLE: {
      pgrp: DP_PROFILES_SEARCH,
      page: DP_PROFILES_SEARCH,
    },
  },
  SHOPPING: {
    IMPRESSION: {
      pgrp: DATA_PRIVACY_SHOPPING,
      page: DATA_PRIVACY_SHOPPING,
    },
    TURNON_BTN: {
      pgrp: DATA_PRIVACY_SHOPPING,
      page: DATA_PRIVACY_SHOPPING,
      link: 'turnon',
    },
    TURNOFF_BTN: {
      pgrp: DATA_PRIVACY_SHOPPING,
      page: DATA_PRIVACY_SHOPPING,
      link: 'turnoff',
    },
    SUCCESS_IMPRESSION: {
      pgrp: DATA_PRIVACY_SHOPPING_SUCCESS,
      page: DATA_PRIVACY_SHOPPING_SUCCESS,
    },
    SUCCESS_DONE: {
      pgrp: DATA_PRIVACY_SHOPPING_SUCCESS,
      page: DATA_PRIVACY_SHOPPING_SUCCESS,
      link: 'done',
    },
    HOW_IT_WORKS: {
      pgrp: DATA_PRIVACY_SHOPPING,
      page: DATA_PRIVACY_SHOPPING,
      link: 'howitworks',
    },
    EMAIL_PREFERENCES: {
      pgrp: DATA_PRIVACY_SHOPPING,
      page: DATA_PRIVACY_SHOPPING,
      link: 'emailpreferences',
    },
    BACK_NAVIGATION: {
      pgrp: DATA_PRIVACY_SHOPPING,
      page: DATA_PRIVACY_SHOPPING,
      link: 'backnavigation',
    },
  },

  PERSONALIZATION: {
    PAYPAL: {
      IMPRESSION: {
        pgrp: DATA_PRIVACY_PERSONALIZATION_PAYPAL,
        page: DATA_PRIVACY_PERSONALIZATION_PAYPAL,
      },
      OPT_TOGGLE: {
        pgrp: DATA_PRIVACY_PERSONALIZATION_PAYPAL_TOGGLE,
        page: DATA_PRIVACY_PERSONALIZATION_PAYPAL_TOGGLE,
      },
    },
    OTHER: {
      IMPRESSION: {
        pgrp: DATA_PRIVACY_PERSONALIZATION_OTHER,
        page: DATA_PRIVACY_PERSONALIZATION_OTHER,
      },
      OPT_TOGGLE: {
        pgrp: DATA_PRIVACY_PERSONALIZATION_OTHER_TOGGLE,
        page: DATA_PRIVACY_PERSONALIZATION_OTHER_TOGGLE,
      },
    },
  },
  CLOSED_ACCOUNT: {
    SENT_IMPRESSION: {
      pgrp: CLOSED_ACCOUNT_SMSSENT,
      page: CLOSED_ACCOUNT_SMSSENT,
    },
    DONE_BTN: {
      pgrp: DATA_PRIVACY_CLOSEDACCOUNT,
      page: DATA_PRIVACY_CLOSEDACCOUNT,
      link: 'donebtn',
    },
    FAQ_LINK: {
      pgrp: DATA_PRIVACY_CLOSEDACCOUNT,
      page: DATA_PRIVACY_CLOSEDACCOUNT,
      link: 'faq_link',
    },
    SIGNUP_LINK: {
      pgrp: DATA_PRIVACY_CLOSEDACCOUNT,
      page: DATA_PRIVACY_CLOSEDACCOUNT,
      link: 'signup_link',
    },
    LINK_EXPIRED_IMPRESSION: {
      pgrp: CLOSED_ACCOUNT_LINKEXPIRED,
      page: CLOSED_ACCOUNT_LINKEXPIRED,
    },
    CONTACT_US_LINK: {
      pgrp: CLOSED_ACCOUNT_LINKEXPIRED,
      page: CLOSED_ACCOUNT_LINKEXPIRED,
      link: 'contact_us_link',
    },
    SOMETHING_WRONG_IMPRESSION: {
      pgrp: CLOSED_ACCOUNT_SOMETHINGWRONG,
      page: CLOSED_ACCOUNT_SOMETHINGWRONG,
    },
  },

  LOGGED_OUT: {
    WELCOME_IMPRESSION: {
      pgrp: LOGGED_OUT_WELCOME,
      page: LOGGED_OUT_WELCOME,
    },
    START_REQUEST_BTN: {
      pgrp: LOGGED_OUT_START_REQUEST_BTN,
      page: LOGGED_OUT_START_REQUEST_BTN,
      link: 'start_a_data_request',
    },
    ALREADY_REQUESTED_LINK: {
      pgrp: LOGGED_OUT_ALREADY_REQUESTED_LINK,
      page: LOGGED_OUT_ALREADY_REQUESTED_LINK,
      link: 'already_requested',
    },
    MANAGE_YOUR_DATA_LINK: {
      pgrp: LOGGED_OUT_MANAGE_YOUR_DATA,
      page: LOGGED_OUT_MANAGE_YOUR_DATA,
      link: 'manage_your_data',
    },
    CREATE_DATE_REQUEST_BTN: {
      pgrp: LOGGED_OUT_CREATE_REQUEST_BTN,
      page: LOGGED_OUT_CREATE_REQUEST_BTN,
      link: 'create_a_data_request',
    },
    ALREADY_REQUESTED: {
      pgrp: LOGGED_OUT_WELCOME,
      page: LOGGED_OUT_WELCOME,
      link: 'already_requested',
    },
    DATA_PRIVACY_SETTINGS_LINK: {
      pgrp: LOGGED_OUT_WELCOME,
      page: LOGGED_OUT_WELCOME,
      link: 'data_privacy_settings_link',
    },
    CREATE_DATA_REQUEST_IMPRESSION: {
      pgrp: LOGGED_OUT_CREATE_REQUEST,
      page: LOGGED_OUT_CREATE_REQUEST,
    },
    CREATE_DATA_REQUEST_SUBMIT: {
      pgrp: LOGGED_OUT_CREATE_REQUEST,
      page: LOGGED_OUT_CREATE_REQUEST,
      link: 'create_request_submit_link',
    },
    CONFIRM_YOUR_MAIL_IMPRESSION: {
      pgrp: LOGGED_OUT_CONFIRM_MAIL,
      page: LOGGED_OUT_CONFIRM_MAIL,
    },
    CONFIRM_YOUR_MAIL_SUBMIT: {
      pgrp: LOGGED_OUT_CONFIRM_MAIL,
      page: LOGGED_OUT_CONFIRM_MAIL,
      link: 'submit_another_request',
    },
    TRACK_YOUR_DATA_REQUEST_IMPRESSION: {
      pgrp: LOGGED_OUT_TRACK_REQUEST,
      page: LOGGED_OUT_TRACK_REQUEST,
    },
    TRACK_YOUR_DATA_REQUEST_CONTINUE_BTN: {
      pgrp: LOGGED_OUT_TRACK_REQUEST,
      page: LOGGED_OUT_TRACK_REQUEST,
      link: 'continue_button',
    },
    QUICK_SECURITY_IMPRESSION: {
      pgrp: LOGGED_OUT_QUICK_SECURITY,
      page: LOGGED_OUT_QUICK_SECURITY,
    },
    QUICK_SECURITY_CONTINUE_BTN: {
      pgrp: LOGGED_OUT_QUICK_SECURITY,
      page: LOGGED_OUT_QUICK_SECURITY,
      link: 'quick_security_continue_button',
    },
    ENTER_CODE_IMPRESSION: {
      pgrp: LOGGED_OUT_OTP_CODE,
      page: LOGGED_OUT_OTP_CODE,
    },
    ENTER_CODE_SUBMIT: {
      pgrp: LOGGED_OUT_OTP_CODE,
      page: LOGGED_OUT_OTP_CODE,
      link: 'enter_your_code_submit',
    },
    ENTER_CODE_RESEND_LINK: {
      pgrp: LOGGED_OUT_OTP_CODE,
      page: LOGGED_OUT_OTP_CODE,
      link: 'enter_your_code_resend_code',
    },
    STATUS_IMPRESSION: {
      pgrp: LOGGED_OUT_STATUS,
      page: LOGGED_OUT_STATUS,
    },
    STATUS_CLOSE: {
      pgrp: LOGGED_OUT_STATUS,
      page: LOGGED_OUT_STATUS,
      link: 'close_button',
    },
    THANKS_PAGE_IMPRESSION: {
      pgrp: LOGGED_OUT_THANKS_REQUEST,
      page: LOGGED_OUT_THANKS_REQUEST,
      link: 'enter_your_code_resend_code',
    },
    THANKS_PAGE_CREATE_NEW_REQUEST: {
      pgrp: LOGGED_OUT_THANKS_REQUEST,
      page: LOGGED_OUT_THANKS_REQUEST,
      link: 'create_a_new_request',
    },
    EMAIL_LINK_EXPIRED_IMPRESSION: {
      pgrp: LOGGED_OUT_LINK_EXPIRED,
      page: LOGGED_OUT_LINK_EXPIRED,
    },
    EMAIL_LINK_EXPIRED_NEW_REQUEST: {
      pgrp: LOGGED_OUT_LINK_EXPIRED,
      page: LOGGED_OUT_LINK_EXPIRED,
      link: 'create_a_new_request',
    },
    EMAIL_LINK_CANT_CONFIRMED_IMPRESSION: {
      pgrp: LOGGED_OUT_EMAIL_NOT_CONFIRMED,
      page: LOGGED_OUT_EMAIL_NOT_CONFIRMED,
    },
    EMAIL_LINK_CANT_CONFIRMED_TRY_AGAIN: {
      pgrp: LOGGED_OUT_EMAIL_NOT_CONFIRMED,
      page: LOGGED_OUT_EMAIL_NOT_CONFIRMED,
      link: 'try_again_link',
    },
    VERIFICATION_CLOSED_IMPRESSION: {
      pgrp: LOGGED_OUT_VERIFICATION_CLOSED,
      page: LOGGED_OUT_VERIFICATION_CLOSED,
    },
  },
  LINKED_ACCOUNTS: {
    LINKED_ACCOUNTS_FOUND: {
      pgrp: LINKED_ACC_FOUND,
      page: LINKED_ACC_FOUND,
    },
    CONTINUE_BTN: {
      pgrp: LINKED_ACC_PAGE,
      page: LINKED_ACC_PAGE,
      link: 'continue_button',
    },
    NOT_NOW_LINK: {
      pgrp: LINKED_ACC_PAGE,
      page: LINKED_ACC_PAGE,
      link: 'not_now_link',
    },
  },
  TETHER_ID: {
    FACESCAN: {
      IMPRESSION: {
        pgrp: FACESCAN_PAGE,
        page: FACESCAN_PAGE,
      },
      REDIRECT_PRIVACY_LANDING_PAGE: {
        pgrp: FACESCAN_PAGE_MOVE_BTN,
        page: FACESCAN_PAGE_MOVE_BTN,
      },
    },
  },
  VENMO_PASSWORD_PAGE: {
    PASSWORD_SENT: {
      pgrp: VENMO_PASSWORD_SENT,
      page: VENMO_PASSWORD_SENT,
    },
    PASSWORD_SOMETHING_WRONG: {
      pgrp: VENMO_PASSWORD_WRONG,
      page: VENMO_PASSWORD_WRONG,
    },
    PASSWORD_EXPIRED: {
      pgrp: VENMO_PASSWORD_EXPIRED,
      page: VENMO_PASSWORD_EXPIRED,
    },
  },
}
export default DATAPRIVACY_FPTI
